import {Component} from '@angular/core';

@Component({
    selector: 'course-classes-support-article',
    template: `
        <ng-container i18n="@@support.articles.classes">
            <p>Classes may be used to group students. A student must always be enrolled in a specific class.</p>
            <p>Don't need multiple classes? Then create one class and add all your students to it.</p>
        </ng-container>
    `
})
export class ClassesSupportArticleComponent {
}
